var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"29","height":"29","rx":"2","fill":"#12155F","key":0}),React.createElement("g",{"clipPath":"url(#clip0)","key":1},React.createElement("path",{"d":"M17.6637 8.15479H19.3983V5.13379C19.099 5.09262 18.0698 5 16.8713 5C14.3704 5 12.6572 6.57304 12.6572 9.46421V12.125H9.89746V15.5022H12.6572V24H16.0408V15.503H18.6889L19.1093 12.1258H16.04V9.79908C16.0408 8.82296 16.3036 8.15479 17.6637 8.15479Z","fill":"white"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"19","height":"19","fill":"white","transform":"translate(5 5)"})))]);
}

FacebookInline.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
